export const calculateTimeSince = (date?: string): string => {
  if (!date) return 'N/A';

  const now = new Date();
  const then = new Date(date);
  const diffMs = now.getTime() - then.getTime();

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 60) {
    if (diffMinutes < 1) {
      return 'Just now';
    }
    return `${diffMinutes} minutes ago`;
  }

  if (diffHours < 24) {
    return `${diffHours} hours ago`;
  }

  if (diffDays < 7) {
    return `${diffDays} days ago`;
  }

  if (diffDays < 30) {
    return `${Math.floor(diffDays / 7)} weeks ago`;
  }

  if (diffDays < 365) {
    return `${Math.floor(diffDays / 30)} months ago`;
  }

  return `${Math.floor(diffDays / 365)} years ago`;
};
